import React, { useState, useEffect } from 'react';
import '../styles/section.css';
import pic1 from '../images/pic1.jpg';
import pic2 from '../images/pic2.png';
import pic3 from '../images/pic3.png';
import pic4 from '../images/pic4.png';

export default function Section() {
  const images = [pic2, pic1, pic3, pic4];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className='home'>
      <div
        className='background'
        style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
      >
        <h1>
          Rêvez grand<br/>
          Nous vous aidons à réussir!
        </h1>
        <div className='home_container'></div>
      </div>
    </div>
  );
}
